import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "fb_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (item) => {
    // item: { type, ref_id, name, price, quantity, custom_flavours?, image_url? }
    setItems((prev) => {
      // For custom boxes, always add as new line because flavours differ.
      if (item.type === "custom_box") return [...prev, { ...item, key: Date.now() + Math.random() }];
      const idx = prev.findIndex((p) => p.ref_id === item.ref_id && p.type === item.type);
      if (idx >= 0) {
        const clone = [...prev];
        clone[idx] = { ...clone[idx], quantity: clone[idx].quantity + (item.quantity || 1) };
        return clone;
      }
      return [...prev, { ...item, key: Date.now() + Math.random(), quantity: item.quantity || 1 }];
    });
  };

  const updateQty = (key, qty) => {
    setItems((prev) => prev.map((p) => (p.key === key ? { ...p, quantity: Math.max(1, qty) } : p)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((p) => p.key !== key));
  const clear = () => setItems([]);

  const subtotal = items.reduce((sum, it) => sum + it.price * it.quantity, 0);
  const count = items.reduce((sum, it) => sum + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
